export enum REFERENTIAL_ENDPOINT {
  ASSET_EVENT_TYPES = "assetEventTypes",
  ASSET_TYPE_CATEGORIES = "assetTypeCategories",
  CONDITION_RATINGS = "conditionRatings",
  CURRENCIES = "currencies",
  INTERVENTION_TYPES = "interventionTypes",
  LANGUAGES = "languages",
  MATERIALS = "materials",
  MODELS = "models",
  PROJECT_COST_TYPES = "additionalProjectCostTypes",
  SCHEDULING_STATES = "schedulingStates",
}
